module.exports = __webpack_public_path__ + "img/Mardona-4.8d96fbb3.webp";